export default __webpack_public_path__ + "./image/2feec9df7f0d136490b3d50540eb5ef7.png";